import {
  CloudUploadOutlined,
  DownloadOutlined,
  SelectOutlined
} from "@ant-design/icons";
import {
  deleteCertificate,
  getAPNDetail,
  getCSR,
  postAppleID,
  uploadCertificate,
} from "@axios/api.enroll";
import {
  Alert,
  Breadcrumb,
  Button,
  Col,
  Image,
  Input,
  Row,
  Spin,
  Steps,
  Upload,
  notification
} from "antd";
import FileSaver from "file-saver";
import { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { gaEvent } from "../../withTracker";

import { useTranslation } from "react-i18next";

const { Step } = Steps;

export const EnrollmentIOSAPN = () => {
  const [step, setStep] = useState<number>(0);
  const [id, setId] = useState<string>("");
  const [detail, setDetail] = useState<any>({});
  const [loading1, setLoading1] = useState<boolean>();
  const [loading, setLoading] = useState<boolean>();
  const [file, setFile] = useState<any>(null);
  const [status, setStatus] = useState<number>(0);

  const { t } = useTranslation();

  useEffect(() => {
    getResult();
  }, []);

  const getCSRURI = () => {
    setLoading1(true);
    getCSR().then((res) => {
      setLoading1(false);
      const type = "application/x-plist";
      const fileName = `${uuidv4()}.plist`;
      FileSaver.saveAs(new Blob([window.atob(res)], { type }), fileName);
    });
  };
  const getResult = () => {
    setLoading(true);
    getAPNDetail().then((res) => {
      if(res){
        setStatus(1);
        setDetail(res);
        setLoading(false);
      }else{
        setStatus(2);
        setLoading(false);
      }

    },()=>{
      setLoading(false);
    });
  };
  const downKeyClick=()=>{
    getCSR().then((res)=>{
       //type：'application/.....'这里是xlsx的类型
       let blob = new Blob([res], { type: 'application/x-plist' });
        let downloadElement = document.createElement('a');
        let href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "mdmSetting.plist"; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
    });

  }
  const uploadFile = (res: any) => {
    const { fileList } = res;
    setFile(null);
    if (fileList && fileList[0]) {
      setFile(fileList[0]?.originFileObj);
    }
  };

  const putAppleID = () => {
    if (id) {
      setLoading1(true);
      postAppleID(id).then(() => {
        getResult();
        setLoading1(false);
      },()=>{
        setLoading1(false);
      });
    } else {
      notification.warning({ message: t("输入Apple ID") });
    }
  };

  const onPrevStep = () => {
    setStep(step - 1);
  };

  const onNextStep = () => {
    if (step === 2) {
      if (file) {
        setLoading1(true);
        uploadCertificate(file).then(
          () => {
            setLoading1(false);
            notification.success({ message: t("上传成功") });
            setStep(step + 1);
          },
          () => setLoading(false)
        );
      } else {
        notification.warning({ message: t("请上传证书文件") });
        return;
      }
    } else {
      setStep(step + 1);
    }
  };

  const beforeUpload2 = (file: File) => {
    const isAPK = file.type === "application/vnd.android.package-archive";
    /*  if (!isAPK) {
      notification.error({ message: "You can only upload APK file!" });
    } */
    const isLt2M = file.size / 1024 / 1024 < 200;
    if (!isLt2M) {
      notification.error({ message: t("Package must smaller than 200MB!") });
    }
    // return isJpgOrPng && isLt2M;
    return false;
  };

  const cancelAPnInfo = () => {
    deleteCertificate().then(
      () => {
        notification.success({message: t("取消关联成功")});
        setStatus(2);
      },
      () => { notification.error({message: t("取消关联失败")}) }
    )
  }

  return (
    <div >
      <div className="breadcrumbTop py-2">
        <Breadcrumb>
          <Breadcrumb.Item>{t("注册")}</Breadcrumb.Item>
          <Breadcrumb.Item>{t("预配置")}</Breadcrumb.Item>
          <Breadcrumb.Item>APNs</Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <Spin spinning={loading}>
        <Row style={{ width: "100%" }}>
          {status == 1 && (
            <>
              <div className="borderBox" style={{ padding: 0 }}>
                <Alert message={<span style={{ fontWeight: 500, fontSize: "1.25rem" }}>APNs {t("绑定成功")}</span>} type="success" showIcon />
              </div>
              <div className="borderBox">
                <div className="mt-3">
                  <table className="table table-bordered">
                    <tbody>
                      <tr>
                        <th>{t("苹果ID")}</th>
                        <td>{detail?.appleId}</td>
                      </tr>
                      <tr>
                        <th>{t("通用名称")}</th>
                        <td>{detail?.commonName}</td>
                      </tr>
                      {/* <tr>
                        <th>Issue By</th>
                        <td>{detail?.issuedBy}</td>
                      </tr> */}
                      <tr>
                        <th>{t("有效期")}</th>
                        <td>{detail?.renewedBy}</td>
                      </tr>
                      <tr>
                        <th>{t("序列号")}</th>
                        <td>{detail?.serialNumber}</td>
                      </tr>
                    </tbody>
                  </table>
                  <div className="text-center">
                    <Button
                      type="primary"
                      className="updateButton"
                      onClick={() => setStatus(2)}
                    >
                      {t("更新")}
                    </Button>
                    <Button
                      variant="outlined"
                      danger
                      className="cancelButton ms-2"
                      onClick={() => {
                        cancelAPnInfo();
                        gaEvent("enrollmentIosApn", "onClick", "cancelApnInfo");
                      }}
                    >
                      {t("取消关联")}
                    </Button>
                  </div>

                </div>
              </div>
            </>
          )}
          {status == 2 && (
            <div className="borderBox">
              <Alert
                message={t("提示: 绑定苹果设备前,需要先配置APNs")}
                type="warning"
                showIcon
              />
              <Steps current={step} className="mt-4">
                <Step title={t("下载CSR")} description="" />
                <Step title={t("更新证书")} description="" />
                <Step title={t("上传证书")} description="" />
                <Step title={t("保存 Apple ID")} description="" />
              </Steps>
              <Row>
                <Col span={6}></Col>
                <Col span={2} style={{marginTop:"140px",textAlign:"left"}}>
                  {step > 0 && (
                    <a onClick={onPrevStep}>
                      <Image preview={false} width={55} alt="prev" src="/images/prev.png">
                      </Image>
                    </a>
                  )}
                </Col>
                <Col span={8}>
                  <div style={{ height: "500px" }}>
                    {step === 0 && (
                      <div className="text-center py-5">
                        <h4>{t("下载未瓴签名的CSR文件")}</h4>
                        <div className="text-muted mt-3 text-start">
                          {t("此文件包含未瓴账号的信息，只需保存此文件即可，以便下一步上传到苹果")}
                        </div>
                        <Button
                          ghost
                          type="primary"
                          className="w-100 mt-5"
                          size="large"
                          loading={loading1}
                          onClick={() => downKeyClick()}
                        >
                          <DownloadOutlined />
                          {t("下载CSR")}
                        </Button>
                      </div>
                    )}
                    {step === 1 && (
                      <div className="text-center py-5">
                        {/* {detail?.appleId ? (
                      <h3>
                        使用您的 Apple ID 登录 Apple Push
                        Notification，找到你的证书点击renew，然后再上传第一步下载的CSR文件生成证书
                      </h3>
                    ) : (
                      <h3>
                        使用您的 Apple ID 登录 Apple Push
                        Notification，将第一步下载的CSR上传以便生成证书
                      </h3>
                    )} */}
                        <h4>{t("更新苹果推送证书")}</h4>
                        <div className="text-muted mt-3 text-start">
                          {t("使用您的 Apple ID 登录 Apple Push")}
                          Notification, {t("找到你的证书点击renew, 然后再上传第一步下载的CSR文件生成证书, 根据提示继续，然后下载苹果推送证书。")}
                        </div>
                        <div>
                          <Button
                            className="w-100 mt-5"
                            ghost
                            type="primary"
                            target="_blank"
                            size="large"
                            href="https://identity.apple.com/pushcert/"
                          >
                            <SelectOutlined /> {t("打开APNs网站")}
                          </Button>
                        </div>
                      </div>
                    )}
                    {step === 2 && (
                      <div className="text-center py-5">
                        <h4>{t("上传苹果推送证书")}</h4>
                        <div className="text-start text-muted mt-5">
                          {t("将上一步从苹果网站下载下来的苹果推送证书上传到未瓴MDM, 使得未瓴MDM和苹果能够建立连接。")}
                        </div>
                        <div className="w-100 mt-5">
                          <Upload
                            accept=".pem"
                            listType="text"
                            showUploadList={true}
                            beforeUpload={beforeUpload2}
                            maxCount={1}
                            onChange={uploadFile}
                          >
                            <Button
                              icon={<CloudUploadOutlined />}
                              size="large"
                              type="primary"
                              ghost
                              style={{ width: "450px" }}
                            >
                              {t("点击上传, 证书文件以pem结尾")}
                            </Button>
                          </Upload>
                          {loading1 ? "Loading..." : null}
                        </div>
                      </div>
                    )}
                    {step === 3 && (
                      <div className="text-center py-5">
                        <h4>{t("填写您的Apple ID")}</h4>
                        <div className="text-muted text-start mt-5">
                          {t("证书有效期一年,再次输入您的Apple ID,以便收到证书过期的提醒")}
                        </div>
                        <div className="text-start mt-3">
                          <label htmlFor="">Apple ID：</label>
                          <Input
                            placeholder={t("输入Apple ID")}
                            style={{ width: "360px" }}
                            value={id}
                            onChange={(e) => setId(e.target.value)}
                          ></Input>
                        </div>
                      </div>
                    )}
                  </div>
                </Col>
                <Col span={2} style={{marginTop:"140px",textAlign:"right"}}>
                  {step < 3 && (
                    <a onClick={onNextStep}>
                      <Image preview={false} width={55} alt="next" src="/images/next.png">
                      </Image>
                    </a>
                  )}
                  {step === 3 && (
                    <a onClick={() => {putAppleID();}}>
                      <Image preview={false} width={55} alt="next" src="/images/next.png">
                      </Image>
                    </a>
                  )}
                </Col>
                <Col span={6}></Col>
              </Row>
              
            </div>
          )}
        </Row>
      </Spin>
    </div>
  );
};
